import {useState, useCallback} from 'react';
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {Form, message} from "antd";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import MicroQualificationService from "../../../../../../services/MicroQualificationService";
import {getMicroQualificationById} from "../../../../../../store/slices/MicroqualificationSaveSlice";

export const useMicroQualificationActions = (dataId) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [commentForm] = Form.useForm();
    const [openViewComment, setOpenViewComment] = useState(false);

    const sendBackMicroqualification = useCallback(async () => {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        try {
            await MicroQualificationService.sendBackToModerator(dataId);
            message.destroy();
            message.success(<IntlMessage id={'success'}/>, 5);
            navigate("/p/microqualification");
        } catch (error) {
            message.destroy();
            message.error(<IntlMessage id={'error'}/>, 5);
        }
    }, [dataId, navigate]);

    const approveMicroqualification = useCallback(async () => {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        try {
            await MicroQualificationService.approveMicroqualifation(dataId);
            message.destroy();
            message.success(<IntlMessage id={'success'}/>, 5);
            navigate("/p/microqualification");
        } catch (error) {
            message.destroy();
            message.error(<IntlMessage id={'error'}/>, 5);
        }
    }, [dataId, navigate]);

    const commentMicroqualification = useCallback(async () => {
        const comment = commentForm.getFieldValue('comment');
        message.loading(<IntlMessage id={'loading'}/>, 0);
        try {
            await MicroQualificationService.commentMicroqualifation(comment, dataId);
            message.destroy();
            message.success(<IntlMessage id={'success'}/>, 5);
            setOpenViewComment(false);
            dispatch(getMicroQualificationById({id: dataId}));
        } catch (error) {
            message.destroy();
            message.error(<IntlMessage id={'error'}/>, 5);
        }
    }, [dataId, commentForm, dispatch]);

    return {
        commentForm,
        openViewComment,
        setOpenViewComment,
        sendBackMicroqualification,
        approveMicroqualification,
        commentMicroqualification
    };
};
